import React from "react";
import LookupAdmin, { ActiveChip } from "../../components/LookupAdmin";

const config = {
  title: "Centros de Custo",
  subtitle: "Dividem despesas por área ou operação, para saber onde o dinheiro está sendo gasto.",
  endpoint: "/finance/cost-centers",
  labelField: "name",
  fields: [
    { name: "name", label: "Nome", required: true, span: 5 },
    { name: "description", label: "Descrição", span: 5 },
    { name: "active", label: "Ativo", type: "boolean", defaultValue: true }
  ],
  columns: [
    { key: "name", label: "Nome" },
    { key: "description", label: "Descrição" },
    { key: "active", label: "Status", render: (c) => <ActiveChip active={c.active} /> }
  ]
};

const CostCenters = () => <LookupAdmin config={config} />;
export default CostCenters;
